// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// dependencies
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const UserAttributeSync = (props) => {
  useRetractSidebar()

  return (
    <div id="user-attribute-sync-page">
      <EntityEditForm
        entities="user-attribute-syncs"
        id={props.match.params.id}
        fields={[
          { name: 'name' },
          { name: 'attributes' },
          { name: 'source' },
          { name: 'destination' },
          { name: 'write_key' },
        ]}
        resource="User Attribute Syncs"
      />
    </div>
  )
}

export default UserAttributeSync
